<template>
  <div class="empty-content__wrappers">
    <div style="text-align: center">
      <img src="/image/static/img/nodata.png" style="width: 120px;" />
      <div class="mt-2">
        {{ text || $l('INDEX.tips_no_data') || '暂无数据！' }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: { text: { type: String, default: '' } },
}
</script>

<style lang="scss" scoped>
.empty-content__wrappers {
  height: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #606266;
  font-size: 13px;
}
</style>
